module.exports = __webpack_public_path__ + "img/banner3_4_zh.6dcf9c0f.png";